
import JobPopupCard from "@/components/job/jobpage/JobPopupCard"
import JobPageBaseInfo from "@/components/job/jobpage/JobPageBaseInfo"
import ContactPersonAvatar from "@/components/base/image/ContactPersonAvatar"
import themes from "@/mixins/themes"
import multiEventListener from "@/mixins/multiEventListener"
import { mdiInformationOutline } from "@mdi/js"
import {
    OABALYTICS_APPLY_CLICK,
    OABALYTICS_APPLY_SHOW,
} from "@/enums/oabalytics"

export default {
    name: "JobPopupV3",
    components: {
        Button: () => import("@/components/base/Button"),
        JobPopupCard,
        JobPageBaseInfo,
        ContactPersonAvatar,
    },
    mixins: [themes, multiEventListener],
    props: {
        job: {
            type: Object,
            required: true,
        },
        /** Menu model INFO */
        info: {
            type: Boolean,
            default: false,
        },
        /** Menu model APPLY */
        apply: {
            type: Boolean,
            default: false,
        },
        /** Enables info popup & button */
        enableInfo: {
            type: Boolean,
            default: false,
        },
        /** Enables apply popup & button */
        enableApply: {
            type: Boolean,
            default: false,
        },
        /** Shows badge for the contact person avatar */
        showBadge: {
            type: Boolean,
            default: false,
        },
        /** Disables outside click handling */
        disableOutsideClick: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["update:info", "update:apply", "interested-external"],
    inject: {
        editorMode: { default: false },
    },
    data: () => ({
        currentPopupCardStep: 0,
    }),
    icons: {
        mdiInformationOutline,
    },
    computed: {
        applyContentClasses() {
            const classes = [
                "job-popup-menu",
                "apply-menu",
                "rounded-3",
                "overflow-visible",
            ]
            if (this.oaTheme.backgroundPrimary.isTextDark)
                classes.push("shadow-4-strong")
            else classes.push("shadow-4-strong--light")
            return classes.join(" ")
        },
    },
    watch: {
        apply(newVal) {
            if (newVal) {
                this.currentPopupCardStep = 0
            }
        },
    },
    mounted() {
        // prevent other click events from firing when clicking outside the info-card/apply-card
        this.addEventListeners(
            document,
            ["touch", "click"],
            this.outsideClickHandler,
            {
                capture: true,
            }
        )
        if (!this.editorMode) {
            this.$oabalytics.trackEvent(OABALYTICS_APPLY_SHOW, {
                job_id: this.job.id,
                abTesting_group: this.$abTesting.isB ? "B" : "A",
            })
        }
    },
    methods: {
        outsideClickHandler(e) {
            if (this.disableOutsideClick) return
            const infoCardEl = this.$refs["info-card"]?.$el
            const applyCardEl = this.$refs["apply-card"]?.$el
            if (infoCardEl && !infoCardEl.contains(e.target) && this.info) {
                this.$emit("update:info", false)
                e.stopPropagation()
                e.preventDefault()
            } else if (
                applyCardEl &&
                !applyCardEl.contains(e.target) &&
                this.apply
            ) {
                e.stopPropagation()
                e.preventDefault()
            }
        },
        onApplyClick() {
            this.$oabalytics.trackEvent(OABALYTICS_APPLY_CLICK, {
                job_id: this.job.id,
                abTesting_group: this.$abTesting.isB ? "B" : "A",
            })
            this.$emit("update:apply", true)
        },
    },
}
